import {Parameter} from '../commons/parameterModel';
import {getParameterFormat} from './expressionParamModel';
import {
  buildListResultOf,
  InferredType,
  isListType,
  ResultTypesEnum,
  StringLikeResults,
} from './infer/internal';

const CompatibleResultGroups: Partial<Record<ResultTypesEnum, ReadonlyArray<InferredType>>> = {
  [ResultTypesEnum.STRING]: StringLikeResults,
};

export function getCompatibleInferredTypesWithManifest(
  parameter: Parameter,
): ReadonlyArray<InferredType> | undefined {
  const config = Parameter.isArray(parameter) ? parameter.items : parameter;
  const formatOrType = getParameterFormat(config, true);

  // undefined means all types are compatible
  if (!formatOrType) {
    return undefined;
  }

  const inferredTypes = CompatibleResultGroups[formatOrType] || [{type: formatOrType}];

  const inferredListTypes = Parameter.isArray(parameter) ? inferredTypes.map(buildListResultOf) : [];
  return [...inferredTypes, ...inferredListTypes];
}

export function isInferredTypeCompatibleWithManifest(
  inferredType: InferredType,
  parameter: Parameter,
): boolean {
  const supportLists = Parameter.isArray(parameter);
  const config = Parameter.isArray(parameter) ? parameter.items : parameter;
  const format = getParameterFormat(config, true);

  if (isListType(inferredType) && !supportLists) {
    return false;
  }

  if (isListType(inferredType) && supportLists) {
    return isInferredTypeCompatibleWithManifest(inferredType.itemType, parameter);
  }

  // Accept any kind of expressions.
  if (!format) {
    return true;
  }

  if (inferredType.type === format) {
    return true;
  }

  const compatibilityList = format && CompatibleResultGroups[format];
  return !!compatibilityList && compatibilityList.includes(inferredType);
}
